import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { Download } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class DownloadService implements HttpService<Download> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<Download[]>> {
        return this.http.get<Download[]>(env.API_URL + '/downloads', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<Download>> {
        return this.http.get<Download>(env.API_URL + '/downloads/' + id, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.download_id) {
                    resp.body.datetime = DateService.toDateString(resp.body.datetime);
                }
                return resp;
            })
        );
    }

    post(t: Download): Observable<HttpResponse<Download>> {
        return throwError(() => new Error("Invalid API service call attempt"));
        /*
        t = this.sanitize(t);
        return this.http.post<Download>(env.API_URL + '/downloads', t, {
            params: {},
            observe: 'response'
        });
        */
    }

    put(t: Download): Observable<HttpResponse<Message>> { 
        return throwError(() => new Error("Invalid API service call attempt"));
        /*
        t = this.sanitize(t);
        return this.http.put<Message>(env.API_URL + '/downloads/' + t.download_id, t, {
            params: {},
            observe: 'response'
        });
        */
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        return throwError(() => new Error("Invalid API service call attempt"));
        /*
        return this.http.delete<Message>(env.API_URL + '/downloads/' + id, {
            params: {},
            observe: 'response'
        });
        */
    }

    /*
    sanitize(t: Download): Download {

        //date
        t.datetime = DateService.to8601String(t.datetime);
        //number
        t.ip_limit = parseInt(t.ip_limit + "");
        //nullable
        //t.middlename = t.middlename == "" ? null : t.middlename;

        return t
    }
        */

}
